export enum CodePrefix {
  ACCOUNT = 'A',
  LOCATION = 'L',
  USER = 'U',
  POOL = 'P',
  STATION = 'S',
}
